import React from "react";
import { RfxListPage } from "../RfxListPage";
import { getRfxListSurface } from "../surfaces/rfx-list-surface";
import { PanelList } from "../components/Panel/PanelList";
import { PanelEmptyState } from "../components/Panel/PanelEmptyState";
import { PANEL_TABS } from "../components/Panel/panelTabAssertion";
import type { RfxListTab } from "../types/rfx-list.type";

interface RfxPanelPageProps {
	companyId?: string;
	path?: string;
	tab?: string;
}

const DEFAULT_TAB: RfxListTab = "current";

const resolveTab = (tab: string | undefined): RfxListTab =>
	(PANEL_TABS as readonly string[]).includes(tab ?? "")
		? (tab as RfxListTab)
		: DEFAULT_TAB;

/**
 * Surface descriptor for this list — tabs, title, hrefs, default tab and data
 * source. Module-level because it is pure data: `useList` is a hook, but it is
 * only *called* during the shell's render, never here.
 */
const surface = getRfxListSurface("panel");

/**
 * Route mount for the Panel scope. `RfxListItemResource` carries `rfx_id` +
 * `rfx_evaluation_id`, deep-linking each row directly to the Evaluation view
 * (or 011's read-only preview when there's no active evaluation) — TASK-019.
 */
export const RfxPanelPage = ({ companyId, tab }: RfxPanelPageProps) => {
	const resolvedTab = resolveTab(tab);

	return (
		<RfxListPage
			surface={surface}
			companyId={companyId}
			tab={tab}
			renderList={(rows, meta, view) => (
				<PanelList rows={rows} meta={meta} view={view} />
			)}
			renderEmptyState={() => <PanelEmptyState tab={resolvedTab} />}
		/>
	);
};
